export default __webpack_public_path__ + "static/media/CRRobusto.230625ae.png";